import CompanyActionTypes from './company.type';

export const setCompany = (company) => ({
  type: CompanyActionTypes.SET_COMPANY,
  payload: company,
});
